import { useState, useEffect } from 'react';
import componentes from '../assets/componentes.png';
import ingenieria from '../assets/ingenieria.png';
import automa from '../assets/autohero.png';
import impneuma from '../assets/impulsandoNeumatica.png';
import tecontroles from '../assets/tecnologiacontroles.png';

const heroContent = [
  // {
  //   title: "R&M COMPONENTES INDUSTRIALES",
  //   description: "Somos distribuidores líderes de componentes industriales, ofreciendo soluciones en neumática, automatización y controles, teflones, perfiles de aluminio, tornillos inoxidables y materiales eléctricos.",
  //   image: ingenieria
  // },
  {
    title: "Soluciones en Neumática",
    description: "Contamos con cilindros, válvulas, mangueras, filtros y reguladores neumáticos de alta calidad. Nuestros sistemas garantizan precisión, durabilidad y eficiencia en la automatización de procesos industriales.",
    image: impneuma
  },
  {
    title: "Tecnología en Controles",
    description: "Ofrecemos soluciones en controles eléctricos y electrónicos: PLCs, relés, sensores y tableros de mando para una operación confiable y segura en todo tipo de entornos industriales.",
    image: tecontroles
  },
  {
    title: "Impulsando la Automatización",
    description: "Con más de 27 años de experiencia, proveemos tecnología de vanguardia para optimizar tus procesos productivos y garantizar la eficiencia de las industrias.",
    image: automa
  },
  {
    title: "Calidad y Servicio",
    description: "Ofrecemos las mejores marcas y productos de calidad, garantizando soluciones confiables para cada necesidad industrial.",
    image: ingenieria
  }
];

const HomeHero = ({ setCurrentPage }) => {
  const [currentContentIndex, setCurrentContentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation for initial load
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100); 
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false); // Fade out current content
      setTimeout(() => {
        setCurrentContentIndex((prevIndex) => (prevIndex + 1) % heroContent.length);
        setIsVisible(true); // Fade in new content
      }, 1000); // Wait for fade out to complete
    }, 7000); // Change content every 7 seconds (1s fade out + 1s fade in + 5s display)
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative bg-gradient-to-br from-red-600 to-red-800 h-[700px] overflow-hidden flex items-center justify-center pt-20">
      {/* Fondo con formas curvas y gradientes */}
      <div className="absolute inset-0">
        <svg className="w-full h-full" viewBox="0 0 1440 700" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0H1440V500C1200 650 800 700 0 500V0Z" fill="url(#paint0_linear)" />
          <defs>
            <linearGradient id="paint0_linear" x1="720" y1="0" x2="720" y2="700" gradientUnits="userSpaceOnUse">
              <stop stopColor="#DC2626"/> {/* Rojo */}
              <stop offset="1" stopColor="#B91C1C"/> {/* Rojo más oscuro */}
            </linearGradient>
          </defs>
        </svg>
      </div>
      
      {/* Contenido */}
      <div className="relative max-w-7xl mx-auto px-6 text-center md:text-left z-10 grid grid-cols-1 md:grid-cols-2 items-center gap-8">
        {/* Columna de texto */}
        <div className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h1 className="text-5xl md:text-6xl font-extrabold text-white mb-4 leading-tight drop-shadow-lg animate-fadeInUp">
            {heroContent[currentContentIndex].title}
          </h1>
          <p className="text-lg md:text-xl mb-8 text-gray-200 max-w-xl animate-fadeInUp delay-200">
            {heroContent[currentContentIndex].description}
          </p>
          <button 
            onClick={() => setCurrentPage('catalogo')} // Lleva a la página de servicios/departamentos
            className="bg-white text-red-600 hover:bg-gray-100 font-bold py-3 px-10 rounded-full text-xl transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl animate-fadeInUp delay-400"
          >
            Catálogo
          </button>
        </div>

        {/* Columna de imagen ilustrativa */}
        <div className={`relative flex justify-center md:justify-end transition-all duration-1000 ease-out delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <img 
            src={heroContent[currentContentIndex].image}// Reemplazar con tu ilustración
            alt="Equipo en reunión de trabajo" 
            className="w-full max-w-2xl h-auto animate-float"
          />
          {/* Íconos sobre la ilustración */}
          <div className="absolute top-1/4 left-1/4 bg-white p-2 rounded-full shadow-lg transform -translate-x-1/2 -translate-y-1/2 animate-pulse-slow">
            <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h10m-9 4h4m-4 2h4M9 5h6a2 2 0 012 2v10a2 2 0 01-2 2H9a2 2 0 01-2-2V7a2 2 0 012-2z" /></svg>
          </div>
          <div className="absolute bottom-1/4 right-1/4 bg-white p-2 rounded-full shadow-lg transform translate-x-1/2 translate-y-1/2 animate-pulse-slow animation-delay-1000">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /></svg>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomeHero;